module["exports"] = [
  "#{male_first_name} #{male_last_name}",
  "#{male_last_name} #{male_first_name}",
  "#{male_first_name} #{male_first_name} #{male_last_name}",
  "#{female_first_name} #{female_last_name}",
  "#{female_first_name} #{male_last_name}",
  "#{female_last_name} #{female_first_name}",
  "#{female_first_name} #{female_first_name} #{female_last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/name/name.js
// module id = 1764
// module chunks = 0